module.exports = {
  DefaultDashboard: 'Default dashboard',
  Edit: 'Edit',
  PleaseSelectABranch: 'Please select a branch',
  PleaseSelectADepartment: 'Please select a department',
  PleaseChooseDepartmentPersonnel: 'Please choose department personnel',
  BIDashboardSource: 'BI dashboard source',
  SelectBIDashboardSource: 'Please select the source of the BI dashboard',
  BiExpiredTip: 'Dear user, the BI module you purchased has expired.<br>Please renew and continue using. You can contact your salesperson or customer service.<br><div style="margin-top: 5px;">The BI module will be restricted from access and data will be retained. After renewal, it can be used again.</div>'
}
